import styled from 'styled-components'

// Создание стиля для центрирования Loader
export const LoaderWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100%; /* Или используйте подходящую высоту родительского элемента */
`
